// MapDataContainer.js
import React, {useEffect, useState} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Tabs, Tab, IconButton, darken } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MapPoiInfo from '../map_poi_all/MapPoiInfo';
import MapVehRoute from './MapVehRoute';
import { MapMode } from './MapShell';
import { useAlertSetter } from '../../api/app-hook';
import { AppNumber, AppObject, AppStyle, AppWord } from '../../value/AppConst';
import NaverSearch from './NaverSearch';
import MapVehPosListRepeat from '../rtd_term_pos/MapVehPosListRepeat';
import { useLazyQuery, useMutation, useReactiveVar } from '@apollo/client';
import { mapPoiAllListRepo, modalWorkRepo, userInfoRepo } from '../../value/AppModel';
import { LIST_MAP_POI_BY_DC, MapPoiAllDictionary } from '../map_poi_all/MapPoiAllDict';
import { SET_ZONE_STORE_INFO } from '../store_info/StoreInfoGql';
import { SET_ZONE_DC_INFO } from '../dc_info/DcInfoGql';
import { useSnackbar } from 'notistack';
import MapPoiInfoInput from '../map_poi_all/MapPoiInfoInput';

const DataContainer = styled(Box)({
    flexGrow:1, display:'flex', flexDirection:'column', height:'100%'
});
const DataBox = styled(Box)({flexGrow:1, display:'flex'});
const WaitBox = styled(Box)({flexGrow:1, display:'flex', alignItems:'center'});

const TheHeader = styled(Box)({
    display:'flex', alignItems:'baseline', backgroundColor:AppStyle.HeaderBackgroundColor, color:'white'
});
// In TheHead
const TabBox = styled(Box)({display:'flex', alignItems:AppWord.END, height:'100%'});
const RouteOrPoiHeader = styled(Box)({
    display:'flex', alignItems:'center', height:'100%', width:'100%'
});
const RouteTitle = styled(Box)({
    flexGrow:1, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.1rem', fontWeight:'bold',
    marginLeft:15, paddingLeft:10, border:'2px solid white', //backgroundColor: AppPalette.HeaderBackground,
    borderRadius:40, backgroundColor: darken(AppStyle.PrimaryRGB, 0.2)
});
const RouteCloseBox = styled(Box)({flexGrow:1, justifyContent:AppWord.END,});

const PoiEditorTitle = styled(Box)({
    display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.1rem', fontWeight:'bold', marginLeft:15,
});

// export const MapMenu = {Pos:1, Loc:2, Naver:3};
const TabCommands = [
    {value: MapMode.VehPos, label:'위치, 경로', default: true},
    {value: MapMode.POI, label:'지점'},
    {value: MapMode.NaverSearch, label:'주소검색'},
];
// TODO: 점포사용자는 위치만 나오도록 해야 함.
const TabCommandsForStore = [
    {value: MapMode.VehPos, label:'위치', default: true},
];

/**
 * 하위 컨트롤러들과 지도와의 인터페이스. 조정 역할.
 */
export default function MapDataContainer({
    mapShell,
    mapMenu,
    onChangeMapMenu,
    onMouseEnterIndexCell,
}) {
    const sessionInfo = useReactiveVar(userInfoRepo);
    const [tabs, setTabs] = useState([]);
    const modalWork = useReactiveVar(modalWorkRepo);
    const mapPoiAllListData = useReactiveVar(mapPoiAllListRepo);
    // const [routeState, setRouteState] = useState({showRoute:false});
    const [poiEdit, setPoiEdit] = useState({open:false}); // {open, item}
    // const [responseAlert, setResponseAlert] = useState(null);
    const addAlert = useAlertSetter();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    // const poiEditCommand = useReactiveVar(poiEditCommandRepo);
    // ##### Call GraphQL
    const [getMapPoiListByDc, responsePoiList]
    = useLazyQuery(LIST_MAP_POI_BY_DC, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetPoiListByDc(data, option)},
		onError: (error) => addAlert({title: MapPoiAllDictionary.errorTitle.Get, message: [error.message]})
    });
    const [setZoneStoreInfo, responseSetZoneStoreInfo] = useMutation( SET_ZONE_STORE_INFO, {
		onCompleted: (data, option) => onCompleteSetZoneStoreInfo(data, option),
		onError: (error) => {addAlert({
            title: "점포 위치 및 구역설정 저장 오류",
            message: [error.message]
        })}
	} );
    const [setZoneDcInfo, responseSetZoneDcInfo] = useMutation( SET_ZONE_DC_INFO, {
        onCompleted: (data, option) => onCompleteSetZoneDcInfo(data, option),
        onError: (error) => {addAlert({
            title: "DC 위치 및 구역설정 저장 오류",
            message: [error.message]
        })}
    });

    useEffect(() => {
        if(sessionInfo.isStoreUser()) setTabs(TabCommandsForStore);
        else setTabs(TabCommands);
    }, [sessionInfo]);

    const onClosePoiEditor = () => {
        modalWorkRepo({});
        // Poi 아이콘 드래그 모드를 끈다. 켜는 것은 드래그 이벤트 처리가 필요한 MapPoiInfoInput에서 한다.
        mapShell.setOpenPoiEditor(false);
    };

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteSetZoneStoreInfo = (data, clientOption) => {
        if(data.storeInfoSetZone.ok) {
            getMapPoiListByDc({variables:{dcCd:sessionInfo.user.getDcCd()}});
            onClosePoiEditor();
            enqueueSnackbar('점포 위치 및 구역설정이 저장되었습니다', {variant:'success', autoHideDuration:2000});
        }
        else addAlert({
            title: "점포 위치 및 구역설정 저장 오류",
            message: [data.poiInfoEdit.message],
        });
    };

    const onCompleteSetZoneDcInfo = (data, clientOption) => {
        if(data.dcInfoSetZone.ok) {
            getMapPoiListByDc({variables:{dcCd:sessionInfo.user.getDcCd()}});
            onClosePoiEditor();
            enqueueSnackbar('DC 위치 및 구역설정이 저장되었습니다', {variant:'success', autoHideDuration:2000});
        }
        else addAlert({
            title: "DC 위치 및 구역설정 저장 오류",
            message: [data.dcInfoSetZone.message],
        });
    };

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    // 중복이지만 흐름을 이해하기 쉽게 하기 위해 여기서 다시 조회.
    const onCompleteGetPoiListByDc = (data, clientOption) => {
        if(data.mapPoiListByDc) {
            mapPoiAllListRepo({
                when: new Date().getTime() / 1000,
                records: data.mapPoiListByDc.map((p)=>{
                    if((!p.lat || !p.lon) && p.xCoord && p.yCoord) {
                        const {lat, lon} = mapShell.katek2ll({x:p.xCoord, y:p.yCoord});
                        p.lat = lat;
                        p.lon = lon;
                        return p;
                    }
                    return p;
                })
            });
        }
    };

    // --------- UI ------------
    const onRequestRefreshPoiList = () => {
        const diff = new Date().getTime() / 1000 - mapPoiAllListData.when;
        if(diff > 3) {
            getMapPoiListByDc({variables:{dcCd:sessionInfo.user.getDcCd()}});
        }
        else enqueueSnackbar(AppWord.ReloadNotIn3Sec, {variant:'info', autoHideDuration:2000});
    };


    const onRequestOpenEditor = (poi) => {
        const copy = {...poi};
        // 과거 경위도를 기록하지 않은 데이터가 있을 수 있다.
        if((!poi.lat && !poi.lon)) {
            if(poi.xCoord && poi.yCoord) {
                const {lat, lon} = mapShell.katek2ll({x:poi.xCoord, y:poi.yCoord});
                copy.lat = lat;
                copy.lon = lon;
            }
            else {
                // 천안의 DC: 36.7444993740362	127.267239706706
                copy.lat = 36.6;
                copy.lon = 127.4;
            }
        }
        modalWorkRepo({openPoiEditor:true, poi});
    };

    const onRequestSetDcZone = (dcInfo) => {
        setZoneDcInfo({variables:{dcInfo}});
    };

    const onRequestSetStoreZone = (storeInfo) => {
        setZoneStoreInfo({variables:{storeInfo}});
    };

    const onClickShowRoute = (vehPos) => {
        mapShell.hideVehPosMarkers();
        //setRouteState({showRoute:true, vehPos: vehPos});
        modalWorkRepo({showRoute:true, vehPos:vehPos});
    };

    // 차량경로를 닫으면 돌아갈 곳은 모든 차량 마커 보여주기이다.
    const onClickCloseRoute = (e) => {
        //setRouteState({showRoute:false});
        modalWorkRepo({});
        mapShell.showVehPosMarkers(true); // true : force to show veh-pos markers.
    };

    // Menu
    const onChangeMenu = (event, newValue) => {
        onChangeMapMenu(newValue);
        if(newValue !== MapMode.NaverSearch) mapShell.clearAddrMarker();
    };

    // 메뉴, 모드에 따라 컴포넌트를 보여준다.
    const renderByMenu = () => {
        if(mapShell) {
            if(modalWork.showRoute) {
                return(
                    <DataBox>
                        <MapVehRoute
                            vehPos={modalWork.vehPos}
                            mapShell={mapShell}
                            onMouseEnterIndexCell={onMouseEnterIndexCell}
                        />
                    </DataBox>
                );
            }
            else if(modalWork.openPoiEditor) {
                return(
                    <DataBox>
                        <MapPoiInfoInput
                            open={modalWork.openPoiEditor}
                            mapShell={mapShell}
                            item={modalWork.poi}
                            onRequestSetDcZone={onRequestSetDcZone}
                            onRequestSetStoreZone={onRequestSetStoreZone}
                            onClose={onClosePoiEditor}
                        />
                    </DataBox>
                );
            }
            return(
                <DataBox>
                    {
                        mapMenu === MapMode.NaverSearch
                        ? <NaverSearch
                            mapShell={mapShell}
                            onMouseEnterIndexCell={onMouseEnterIndexCell}
                            />
                        :
                        mapMenu === MapMode.VehPos
                        ? <MapVehPosListRepeat
                            mapShell={mapShell}
                            onClickShowRoute={onClickShowRoute}
                            onMouseEnterIndexCell={onMouseEnterIndexCell}
                        />
                        :
                        <MapPoiInfo
                            mapShell={mapShell}
                            onRequestOpenEditor={onRequestOpenEditor}
                            responsePoiList={responsePoiList}
                            onRequestRefresh={onRequestRefreshPoiList}
                            onMouseEnterIndexCell={onMouseEnterIndexCell}
                        />
                    }
                </DataBox>
            );
        }
        else return <WaitBox>Wait...</WaitBox>;
    };

    return (
        <DataContainer>
            <TheHeader height={AppNumber.MapHeaderHeight}>
                {
                    modalWork.showRoute
                    ?
                    <RouteOrPoiHeader>
                        <RouteTitle
                            height={AppNumber.MapHeaderHeight-14}
                        >
                            {modalWork.vehPos.vehPlates} 경로
                        </RouteTitle>
                        <RouteCloseBox>
                            <IconButton
                                onClick={onClickCloseRoute}
                                color={AppStyle.mui.inherit}
                            >
                                <CloseIcon/>
                            </IconButton>
                        </RouteCloseBox>
                    </RouteOrPoiHeader>
                    :
                    modalWork.openPoiEditor
                    ?
                    <RouteOrPoiHeader>
                        <PoiEditorTitle>
                            {modalWork.poi.poiName}
                        </PoiEditorTitle>
                    </RouteOrPoiHeader>
                    :
                    <TabBox>
                        <Tabs
                            value={mapMenu || MapMode.VehPos}
                            onChange={onChangeMenu}
                            textColor='inherit' indicatorColor='secondary'
                        >
                            {
                                tabs.map((menu)=>{
                                    return(
                                        <Tab key={menu.value}
                                            value={menu.value}
                                            label={menu.label}
                                        />
                                    );
                                })
                            }
                        </Tabs>
                    </TabBox>
                }
            </TheHeader>
            {renderByMenu()}
        </DataContainer>
    )
}
